import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const BackEntitiesSelectionFeatureKey = 'entitiesselection';

// Clé de sélection par défaut du composant aa-entities-selection (storageKey par défaut '/admin')
export const BackEntitiesSelectionAdminKey = '/admin';

// Clé de sélection propre à la volumétrie de sauvegarde (administration) :
// elle isole le filtre de la page bckp-volumetry de celui partagé '/admin'
export const BackEntitiesSelectionVolumetryKey = '/admin/bckp/volumetry';

export class EntitiesSelectionValue {
    public key: string;

    public all: boolean;
    public entityIds: string[];

    constructor (key: string, all: boolean = true, entityIds: string[] = []) {
        this.key = key;
        this.all = all;
        this.entityIds = entityIds;
    }
}

export const entitiesSelectionAdapter: EntityAdapter<EntitiesSelectionValue> =
    createEntityAdapter<EntitiesSelectionValue>({
        selectId: (value: EntitiesSelectionValue) => value.key
    });

export interface IBackEntitiesSelectionState {
    selections: EntityState<EntitiesSelectionValue>;
}

export const BackEntitiesSelectionInitialState: IBackEntitiesSelectionState = {
    selections: entitiesSelectionAdapter.getInitialState({})
};
